import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  applicationStore,
  BetStatus,
  ListElemText,
  ListItem,
  ListItemCell,
  ListItemCont,
} from '@pascal/pascal-core';
import { parseNumberByPrecision } from '../../../../../helpers';
import { TranslationKeys } from '../../../../../enums/translationKeys';

export const LiveBetsItems = observer(({ data: bet, t }) => {
  const { FreeBet } = TranslationKeys;

  return (
    <ListItemCont
      forRemove={
        bet?.isRoundFinish || bet?.status === BetStatus.Lose || bet?.status === BetStatus.Win
      }
      animationDelayInSeconds={1.5}
    >
      <ListItem active={bet?.winAmount}>
        <ListItemCell>
          <ListElemText style={{ textTransform: 'capitalize' }}>
            {t(TranslationKeys.ME)}
          </ListElemText>
        </ListItemCell>
        <ListItemCell>
          <ListElemText style={{ textTransform: 'lowercase' }}>
            {bet?.freeBetId && !applicationStore.isDemo ? t(FreeBet) : bet?.amount}
          </ListElemText>
        </ListItemCell>
        <ListItemCell>
          <ListElemText>
            {bet?.status === BetStatus.Pending
              ? '- -'
              : `x${parseNumberByPrecision(bet?.odd, 1, 2)}`}
          </ListElemText>
        </ListItemCell>
        <ListItemCell>
          <ListElemText>
            {bet?.status === BetStatus.Pending ? '- - - - - -' : bet?.winAmount}
          </ListElemText>
        </ListItemCell>
      </ListItem>
    </ListItemCont>
  );
});
